const blogs = [
  {
    id: 1,
    title: 'Professional PAN Card Resize Tips & Tricks',
    slug: '/blog/resize-tips',
    excerpt: 'Master resizing PAN cards with professional techniques, correct dimensions and quality-preserving tips for official and web use.',
    image: '/blog1.png',
    date: '2024-01-24',
    category: 'Resizing'
  },
  {
    id: 2,
    title: 'Complete Document Size Guide for PAN Cards',
    slug: '/blog/document-guide',
    excerpt: 'A complete reference on PAN card dimensions, DPI, file formats and best practices for submissions and web presentation.',
    image: '/blog2.png',
    date: '2024-01-20',
    category: 'Specifications'
  },
  {
    id: 3,
    title: 'Best Practices for PAN Card Document Management',
    slug: '/blog/best-practices',
    excerpt: 'Essential do’s and don’ts, security tips and a digital storage strategy to keep your PAN card documents safe and compliant.',
    image: '/blog1.png',
    date: '2024-01-18',
    category: 'Management'
  },
  {
    id: 4,
    title: 'PAN Card: Essential Information & How to Use It',
    slug: '/blog/pan-essential-info',
    excerpt: 'Everything you need to know about your PAN card—what it is, how it is used for taxation and identity verification, and how to check details online.',
    image: '/blog1.png',
    date: '2026-01-30',
    category: 'PAN Card Info'
  },
  {
    id: 5,
    title: 'How to Apply and Update Your PAN Card — Step-by-Step',
    slug: '/blog/pan-apply-update',
    excerpt: 'A practical, up-to-date guide to apply for a new PAN, update details, common mistakes to avoid and documents required for fast processing.',
    image: '/blog2.png',
    date: '2026-01-30',
    category: 'How-To'
  }
];

export default blogs;
